import * as CONST from '../common/const';
import api from 'utils/api';

export const saveJobRequest = () => {
  return {
    type: CONST.SAVE_JOB_REQUEST
  }
}

export const saveJobSuccess = () => {
  return {
    type: CONST.SAVE_JOB_SUCCESS,
  }
}

export const saveJobFailure = (error) => {
  return {
    type: CONST.SAVE_JOB_FAILURE,
    error: error,
  };
};


export const saveJobData = (payload) => async (dispatch, getState) => {
  dispatch(saveJobRequest());
  try {
    let newPayload = {... payload};
    if (payload.hasOwnProperty("calculationDetails") &&
      !(typeof payload.calculationDetails === 'string' || payload.calculationDetails instanceof String)) {
      newPayload.calculationDetails = JSON.stringify(newPayload.calculationDetails);
    }
    await api.saveJobData(newPayload);
    dispatch(saveJobSuccess(payload))
  } catch (e) {
    dispatch(saveJobFailure(e));
  }
};